import PazienteWincareOldEventiList from "./pages/PazienteWincareOldEventiList.vue";

export default {
    PazienteWincareOldEventiList,
};
